import { DESKTOP_MIN_WIDTH, RECEIVER_FILTER_INITIAL } from 'constants';
import { isEmpty } from 'lodash';
import styled from 'styled-components';
import { paragraphMixin } from 'styles';
import { objectUtils } from 'utils';
import { useDetectDevice } from './useDetectDevice';
import usePage from './usePage';

const useBodyContentStatus = ({
  isFetching = false,
  list = null,
  sorts = {},
  filters = null,
  search = '',
}) => {
  const { isDesktop } = useDetectDevice();
  const { isReceiversPage } = usePage();

  if (isReceiversPage) {
    const filterByFavoriteSelected = filters?.favoriteSelected;
    if (filterByFavoriteSelected === RECEIVER_FILTER_INITIAL.favoriteSelected) {
      delete filters?.favoriteSelected;
    }
  }

  const isFilterEmpty =
    isEmpty(filters) || isEmpty(Object.values(filters)?.filter((o) => o));
  const isSortEmpty =
    isEmpty(sorts) || isEmpty(Object.values(sorts)?.filter((o) => o));
  const isSearchEmpty = isEmpty(search);

  const isInitialEmpty = isEmpty(list);
  const isInitialLoaded = !isEmpty(list);
  const isSearched = !isSearchEmpty && !isEmpty(list);
  const isSearchedEmpty = !isSearchEmpty && isEmpty(list);
  const isFiltered = !isFilterEmpty && !isEmpty(list);
  const isFilteredEmpty = !isFilterEmpty && isEmpty(list);
  const isSearchedAndFiltered = isSearched && isFiltered;
  const isSearchedAndFilteredEmpty = isSearchedEmpty && isFilteredEmpty;
  const isSorted = !isSortEmpty && !isEmpty(list);
  const isSearchedAndSorted = isSearched && isSorted;
  const isFilteredAndSorted = isFiltered && isSorted;
  const isSearchedFilteredAndSorted = isSearched & isFiltered && isSorted;

  let isBodyContentNoResult =
    (isSearchedEmpty || isFilteredEmpty || isSearchedAndFilteredEmpty) &&
    !isFetching;
  let isBodyContentEmpty = isInitialEmpty && !isFetching;
  let isBodyContentBlank = isFetching;
  // isBodyContentNoResult = true;
  // isBodyContentEmpty = true;
  // isBodyContentBlank = true;

  const isShowAll =
    isInitialLoaded ||
    !isInitialEmpty ||
    isSearched ||
    isFiltered ||
    isSearchedAndFiltered ||
    isSearchedAndSorted ||
    isFilteredAndSorted ||
    isSearchedFilteredAndSorted ||
    isSorted ||
    !isDesktop;
  const isShowSearchInput =
    isShowAll || isSearchedEmpty || isFilteredEmpty || isFetching;
  const isShowFilterButton =
    isShowAll || isSearchedEmpty || isFilteredEmpty || isFetching;
  const isShowActionButton =
    isShowAll || isSearchedEmpty || isFilteredEmpty || isFetching;
  const isShowPagingButton = isShowAll;

  const isShowPillFiltered = !objectUtils.isObjectEmpty(filters);

  const checkHeadingSortability = (headingUnableSorts = [], heading = '') => {
    if (isEmpty(headingUnableSorts)) return true;
    if (!heading) return false;
    return !headingUnableSorts.includes(heading);
  };

  return {
    // Data status
    isSearched,
    isFiltered,
    isSorted,
    isBodyContentNoResult,
    // Body content status
    isBodyContentEmpty,
    isBodyContentBlank,
    // Input/Button status
    isShowSearchInput,
    isShowFilterButton,
    isShowActionButton,
    isShowPagingButton,
    // utils
    isShowPillFiltered,
    checkHeadingSortability,
  };
};

export const Pill = styled.div`
  ${paragraphMixin};
  font-weight: 500;
  font-size: 14px;
  line-height: 17px;
  color: var(--ds-c-white);
  padding: 4px 8px;
  min-width: fit-content;
  height: 24px;
  background: var(--ds-c-blue);
  border-radius: 100px;

  &:last-child {
    margin-right: 0px;
  }

  & img {
    margin-top: -2px;
    margin-left: 2px;
    cursor: pointer;
  }

  @media screen and (min-width: ${DESKTOP_MIN_WIDTH}px) {
    font-size: 14px;
    line-height: 17px;
  }
`;

export default useBodyContentStatus;
